import { Crown } from "lucide-react";
import { RekapKendaraan } from "../components/RekapKendaraan";

export default function RekapKendaraanPage() {
  return (
    <div data-testid="rekap-kendaraan-page" className="space-y-6 max-w-5xl">
      <div>
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-900 flex items-center gap-2">
          <Crown className="w-7 h-7 text-emerald-700" /> Rekap Kendaraan (Pemilik)
        </h1>
        <p className="text-sm text-zinc-500 mt-1">
          Ringkasan harian per kendaraan dengan tarif ongkos angkut pemilik — khusus Owner/Pemilik
        </p>
      </div>
      <RekapKendaraan mode="owner" title="Ringkasan Harian per Kendaraan (Tarif Pemilik)" />
    </div>
  );
}
